import { useIntl } from "react-intl";

interface ReservationNextStepsProps {
  type: "flight" | "hotel";
}

export const ReservationNextSteps = ({ type }: ReservationNextStepsProps) => {
  const intl = useIntl();
  const showFlightInfo = type === "flight";
  const showHotelInfo = type === "hotel";

  return (
    <section className="mt-4">
      <h3 className="section-title">
        {intl.formatMessage({
          id: "reservations.whatsNext",
          defaultMessage: "What's next?",
        })}
      </h3>
      <div className="section-card flex flex-col gap-2 text-sm">
        {showFlightInfo ? (
          <p>
            {intl.formatMessage({
              id: "reservations.flight.whatsNextDescription",
              defaultMessage:
                "If you would like to pre-select your seat, please enter your ticket number and last name on the airline's website to reserve your seat two hours before takeoff.",
            })}
          </p>
        ) : null}
        {showHotelInfo ? (
          <p>
            {intl.formatMessage({
              id: "reservations.hotel.whatsNextDescription",
              defaultMessage:
                "Provide hotel personnel with reservation number while checking in.",
            })}
          </p>
        ) : null}
      </div>
    </section>
  );
};
